// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mcp-admin__summary-header__summary[data-v-2270b3f8]{margin-left:24px}.mcp-admin__summary-header__value[data-v-2270b3f8]{text-transform:uppercase;margin-right:3px}", ""]);
// Exports
module.exports = exports;
